import React, { useEffect, useRef, useState } from "react";
import { t } from "../../../../Utils/translate";
import utils from "../../../../Utils/index";
import "./medicalNotes.css";

function MedicalNotes({ data }) {
  const [imageList, setImageList] = useState([]);

  useEffect(() => {
    if (data) {
      let temp2 = [];
      data.map((item) => {
        temp2.push({
          image: item.file,
          name: "",
          type: item.fileType === utils.constants.fileType.pdf.toLowerCase() ? utils.constants.fileType.pdf : utils.constants.fileType.image,
          size: 0,
          type_2: item.fileType === utils.constants.fileType.pdf.toLowerCase() ? utils.constants.fileType.pdf : utils.constants.fileType.image,
          id: item._id,
        });
      });
      setImageList(temp2);
      // setUploadedList(temp2)
    }
  }, [data]);

  return imageList.length == 0 ? (
    <div style={{ margin: "auto" }}>
      {/* {isLoading ? <Widgets.CircularLoader /> : ""} */}
      <div>
        <div className="medical-notes-upload text-center">
          <i className="ri-file-upload-line medical-notes-upload-icon"></i>
        </div>
        {
          // finishedAppointmentTiming < 24 ?
          true ? (
            <div className="text-center">
              <h3 className="upload-label">{t("Upload Prescription")}</h3>
              <h5 className="upload-file-desc">{t("Attach Images, PDF, E-Prescription")}</h5>

              <div className="d-flex justify-content-center mt-3">
                <input type="file" accept="image/*" className="hidden" id="imageUpload" />
                <button
                  // onClick={handleImageUpload}
                  className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 mx-[15px] rounded focus:outline-none focus:shadow-outline"
                >
                  Upload Image
                </button>

                <input type="file" accept=".pdf" className="hidden" id="pdfUpload" />
                <button
                  // onClick={handlePdfUpload}
                  className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 mx-[15px] rounded focus:outline-none focus:shadow-outline"
                >
                  Upload PDF
                </button>

                <input type="file" accept=".doc,.docx" className="hidden" id="docUpload" />
                <button
                  // onClick={handleDocUpload}
                  className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 mx-[15px] rounded focus:outline-none focus:shadow-outline"
                >
                  Upload DOC
                </button>
              </div>

              <div className="upload-cases-instruction mt-2">{t("You can only upload 5 documents")}</div>

              {/* Medical Notes Section */}
              <div className="mt-4">
                <h3 className="text-lg font-bold mb-2">Medical Notes:</h3>
                <textarea rows="4" className="w-full border p-2 focus:outline-none focus:shadow-outline" placeholder="Enter medical notes here..."></textarea>
              </div>

              {/* Submit Button */}
              <button
                // onClick={handleSubmit}
                className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 mt-4 rounded focus:outline-none focus:shadow-outline"
              >
                Submit
              </button>
            </div>
          ) : null
        }
      </div>
    </div>
  ) : null;
}

export default MedicalNotes;
